import { v4 as uuidv4 } from 'uuid';

interface ConnectionArgs {
  [key: string]: any;
  retrieve?: boolean;
  learn?: boolean;
}

class Connection {
  id: string;
  type: string;
  connectionArgs: ConnectionArgs;

  constructor(type: string, connectionArgs: ConnectionArgs) {
    this.id = uuidv4().replace(/-/g, '_');
    this.type = type;
    this.connectionArgs = {
      ...connectionArgs,
      retrieve: connectionArgs.retrieve ?? true,
      learn: connectionArgs.learn ?? false
    };
  }

  toJson(): { type: string; connection_args: ConnectionArgs } {
    return {
      type: this.type,
      connection_args: this.connectionArgs // Use snake_case for JSON output
    };
  }

  static fromJson(json: any): Connection {
    return new Connection(
      json.type || '',
      {
        ...(json.connection_args || json.connectionArgs || {}), // Support both formats for backward compatibility
        retrieve: json.retrieve ?? json.connection_args?.retrieve ?? true,
        learn: json.learn ?? json.connection_args?.learn ?? false
      }
    );
  }
}

export default Connection;